module.exports = __WEBPACK_EXTERNAL_MODULE_41__;


//////////////////
// WEBPACK FOOTER
// external "dashboard-analytics/visualizations/vipr/VIPRConfig"
// module id = 41
// module chunks = 0 2 3